import React, { lazy, Suspense } from 'react';
import { Box, Grid, CircularProgress } from '@mui/material';
import AddByEmailContent from 'team/shared/features/addMember/TeamAddByEmailContent';
import ImportCsvContent from 'team/shared/features/addMember/TeamImportCsvContent';
import CreateCompanyPagesContent from 'team/shared/features/addMember/TeamCreateCompanyPagesContent';
import SyncMicrosoftAdContent from 'team/shared/features/addMember/TeamSyncMicrosoftAdContent';

// Use dynamic import for SyncEventbriteContent to avoid circular dependency
const SyncEventbriteContent = lazy(() => import('team/shared/features/addMember/TeamSyncEventbriteContent'));

const TeamAddMemberContent = ({ selectedOption, onDataChange, onValidationChange }) => {
    const renderContent = () => {
        switch (selectedOption) {
            case 'add-email':
                return <AddByEmailContent onDataChange={onDataChange} onValidationChange={onValidationChange} />;
            case 'import-csv':
                return <ImportCsvContent onDataChange={onDataChange} onValidationChange={onValidationChange} />;
            case 'create-pages':
                return <CreateCompanyPagesContent onDataChange={onDataChange} onValidationChange={onValidationChange} />;
            case 'sync-ad':
                return <SyncMicrosoftAdContent onDataChange={onDataChange} onValidationChange={onValidationChange} />;
            case 'sync-eventbrite':
                return (
                    <Suspense fallback={<Box sx={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}><CircularProgress /></Box>}>
                        <SyncEventbriteContent onDataChange={onDataChange} onValidationChange={onValidationChange} />
                    </Suspense>
                );
            default:
                return <AddByEmailContent onDataChange={onDataChange} onValidationChange={onValidationChange} />;
        }
    };

    return (
        <Box sx={{
            flex: 1,
            backgroundColor: '#ffffff',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: { xs: '0.5rem', sm: '0.75rem', md: '1rem', lg: '1.25rem' },
            paddingRight: { xs: '1rem', sm: '1.25rem', md: '1.5rem', lg: '1.75rem' },
            paddingBottom: { xs: '0.5rem', sm: '1rem', md: '1.5rem', lg: '2rem' },
            paddingTop: 0,
        }}>
            <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {renderContent()}
                </Grid>
            </Grid>
        </Box>
    );
};

export default TeamAddMemberContent;

